import { InputComponent } from "components/components/Component";
import { SimpleInputBaseDefinition, SimpleInputBaseComponent } from "components/input/baseInputDefinition";
import { ComponentActionHelper } from "components/events/componentActionHelper";
import { fireDataChangedEvent } from "components/form/dataChangedEventDetail";
import { LabelElement } from "components/components/label/labelElement";
import { FocusManager } from "components/pages/focusManager";
import $ from "jquery";
import template from "./checkboxStylish.hbs";
import "./checkboxStylish.scss";

export class CheckboxStylishInput extends SimpleInputBaseComponent<CheckboxStylishInputDefinition> implements InputComponent {

    public static readonly componentType = "checkboxStylishInput";

    constructor(schema: CheckboxStylishInputDefinition) {
        super(schema);
    }

    //Override superclass method with own properties
    public setDefinition(schema: CheckboxStylishInputDefinition) {
        if (schema.labelKey == null || schema.labelKey.length === 0) {
            this.definition.labelWidth = 0;
        } else {
            this.definition.labelWidth = this.definition.labelWidth ?? 6;
        }
        if (this.definition.emptyWidth == null) {
            this.definition.emptyWidth = 0;
        }
        if (this.definition.inputWidth == null) {
            this.definition.inputWidth = 16 - (this.definition.labelWidth || 0) - this.definition.emptyWidth;
        }
        this.definition.width = this.definition.width ?? 16;
    }

    public render(): Element {
        this.renderTemplate();
        this.bindEvents();
        ComponentActionHelper.register(this);
        return this.view;
    }

    public renderTemplate(): Element {
        return super.renderTemplate(template);
    }

    private bindEvents(): void {

        /*
        this.element = this.view.querySelector("s6-checkbox-stylish-input");
        this.genericBindEvents(this.element, false);
        */
        let input = this.view.querySelector("input");

        input.addEventListener("change", () => {
            fireDataChangedEvent(this, this.view, this.getValue());
        });

        if (this.definition.tabOnEnter === true) {
            input.addEventListener("keydown", (e) => {
                if (e.key === "Enter") {
                    e.stopPropagation();
                    e.preventDefault();
                    FocusManager.focusNext();
                }
            });
        }
    }

    public getValue(): boolean {
        return $(this.view).find("input").prop("checked");
    }

    public value(v: boolean) {
        if (typeof v !== "undefined") {
            $(this.view).find("input").prop("checked", v);
        }
    }

    public setReadOnly(ro: boolean) {
        this.view.querySelector("input").disabled = ro;
    }

    public setRequired(required: boolean) {
        let elementLabel = this.view.querySelector("s6-input-label");
        if (elementLabel != null) {
            (elementLabel as LabelElement).required = required;
        }
    }

    public setValidationStatus(valid: boolean, message?: string) {
        if (valid) {
            $(this.view).find("label").removeClass("is-invalid");
            this.view.querySelector("input").classList.remove("has-error");
        } else {
            $(this.view).find("label").addClass("is-invalid");
            this.view.querySelector("input").classList.add("has-error");
        }
    }
}

export interface CheckboxStylishInputDefinition extends SimpleInputBaseDefinition {
}
